import React from 'react';
import { SectionPanel } from 'ui';
import { MainGridContainer } from 'ui/common/main-grid-container/main-grid-container';
import { MetroLineSection } from 'app/components/metro-line/metro-line-section';
import { ExternalUrlGroupsSectionType } from '../metroline/types';
import { ExternalUrlGroupsSection } from '../types';
import { AccessPolicyTiles } from './access-policy-tiles';
import styles from './access-policy-container.scss';

export const AccessPolicyContainer: React.FC<ExternalUrlGroupsSection> = ({
  externalUrlGroupItem, translation, section, translationAdminAccess, externalUrlAccess,
  accessPolicyValidation, locale, options, validation, getRef, shouldRenderSection, loadOptions,
  updateAccessPolicyItem, removeAccessPolicy, addAccessPolicy, removeAllAccessPolicy,
  resetAccessPolicyClientValidation, resetAccessPolicyServerValidation
}) =>
  <MetroLineSection<ExternalUrlGroupsSectionType>
    section={section}
    sectionType={ExternalUrlGroupsSectionType.accessPolicy}
    getRef={getRef}
    shouldRenderSection={shouldRenderSection}>
    <div ref={getRef(ExternalUrlGroupsSectionType.accessPolicy)}>
      <SectionPanel
        className="admin-paper-top-panel"
        componentId={ExternalUrlGroupsSectionType.accessPolicy}
        validation={undefined}
        info={{ text: translation.access_policy_title }}
        label={{ visible: true, text: translation.access_policy_title }} />
      <MainGridContainer>
        {externalUrlGroupItem.accessPolicy.length === 0
          && <div className={styles.alertInfo}>
            <p>{translation.info_label}</p>
          </div>}
        <AccessPolicyTiles
          externalUrlGroupItem={externalUrlGroupItem}
          accessPolicyValidation={accessPolicyValidation}
          locale={locale}
          options={options}
          translation={translation}
          translationAdminAccess={translationAdminAccess}
          externalUrlAccess={externalUrlAccess}
          validation={validation}
          updateAccessPolicyItem={updateAccessPolicyItem}
          removeAccessPolicy={removeAccessPolicy}
          removeAllAccessPolicy={removeAllAccessPolicy}
          addAccessPolicy={addAccessPolicy}
          resetAccessPolicyClientValidation={resetAccessPolicyClientValidation}
          resetAccessPolicyServerValidation={resetAccessPolicyServerValidation}
          loadOptions={loadOptions} />
      </MainGridContainer>
    </div>
  </MetroLineSection>;
